/**
 * 영업 메일 반응의 클라 창구 — 「보고해 달라」만 한다. 서명·중복·저장은 서버가 정한다.
 *
 * ⛔ 둘 다 **던지지 않는다.** 랜딩과 가입 흐름이 이 호출에 매여선 안 된다.
 */

import {
  readBrowserStorage,
  readStoredOutreachRef,
  clearStoredOutreachRef,
} from 'src/utils/outreach/outreach-ref';

import { fetchIdToken } from 'src/lib/firebase/auth-kit';

/** 링크 유입 보고 — 화면을 떠나는 중에도 나가도록 `keepalive` 로 보낸다 */
export async function reportOutreachClick(params: {
  historyId: string;
  url?: string;
  ref?: string;
  sid?: string;
}): Promise<void> {
  try {
    await fetch('/api/outreach/click', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(params),
      keepalive: true,
    });
  } catch {
    // 반응 추적 실패는 화면에 알리지 않는다
  }
}

/**
 * 가입 보고 — 보관된 유입 표식이 있을 때만. 성공하면 표식을 지워 두 번 보고하지 않는다.
 * 토큰이 없으면(아직 로그인 전) 조용히 건너뛴다.
 */
export async function reportOutreachSignup(): Promise<void> {
  const storage = readBrowserStorage('local');
  if (!storage) return;
  const ref = readStoredOutreachRef(storage);
  if (!ref) return;

  const token = await fetchIdToken();
  if (!token) return;
  try {
    const res = await fetch('/api/outreach/signup', {
      method: 'POST',
      headers: { 'content-type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ historyId: ref.id }),
    });
    if (res.ok) clearStoredOutreachRef(storage);
  } catch {
    // 표식은 남겨 둔다 — 다음 기회에 다시 보고한다
  }
}
